import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import akmApi from "../../../../../apis/akmApi";

import idx from "indonesia-numbering-formatter";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import AddIcon from "@material-ui/icons/Add";
import { TableContainer, Table, TableHead, TableRow, TableBody, TableCell, FormControl, InputLabel, Input, Grid, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

class ListPenjualanVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      isSnackbar: false,
      message: null,
      listPenjualanVoucher: [],
    };
  }

  async componentDidMount() {
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      this.fetchListPaketProgram("");
    }
  }

  fetchListPaketProgram = async (search) => {
    this.setState({ isFetching: true });

    const dataSearch = {
      nomorTransaksi: search,
      keterangan: search,
    };

    await akmApi
      .post(URL_AKM.FETCH_PENJUALAN_LIST + "page=0" + "&size=10", dataSearch)
      .then((response) => {
        this.setState({ isFteching: false });
        if (response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE) {
          console.log(response.data.data.content);
          this.setState({
            isFteching: false,
            listPenjualanVoucher: response.data.data.content,
          });
        } else {
          console.log(response.data.errorSchema.errorMessage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render = () => {
    const { isFetching, listPenjualanVoucher } = this.state;

    return (
      <TableContainer>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Button type="submit" variant="outlined" color="primary" onClick={() => this.props.handleChangeIsFormPenjualanVoucher()}>
              <AddIcon /> &nbsp; Penjualan
            </Button>
          </Grid>
          <Grid item>
            <FormControl>
              <InputLabel htmlFor="standard-adornment-password">Cari Penjualan</InputLabel>
              <Input onChange={(e) => this.fetchListPaketProgram(e.target.value)} placeholder="Cari Penjualan" endAdornment={<SearchIcon position="end" />} />
            </FormControl>
          </Grid>
        </Grid>

        <Table aria-label="collapsible table">
          <TableHead>
            <TableCell align="left">No Transaksi</TableCell>
            <TableCell align="left">Keterangan</TableCell>
            <TableCell align="left">Harga</TableCell>
            <TableCell align="left">Tersedia</TableCell>
            <TableCell align="left">Terpakai</TableCell>
            <TableCell align="left">Status</TableCell>
            <TableCell align="center">#</TableCell>
          </TableHead>
          <TableBody>
            {!__.isEmpty(listPenjualanVoucher) &&
              listPenjualanVoucher.map((val, i) => (
                <TableRow key={i}>
                  <TableCell align="left">{val.nomorTransaksi}</TableCell>
                  <TableCell align="left">{val.keterangan}</TableCell>
                  <TableCell align="left">Rp. {idx.format(val.harga)}</TableCell>
                  <TableCell align="left">{val.jumlahVoucher}</TableCell>
                  <TableCell align="left">{val.jumlahTerpakai}</TableCell>
                  <TableCell align="left">
                    {val.status == "0" ? (
                      <span style={{ color: "green" }}>
                        <CheckCircleIcon />
                      </span>
                    ) : (
                      <span style={{ color: "orange" }}>
                        <CancelIcon />
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {
                      <div className="button-group">
                        <button className="btn btn-outline-info btn-sm" onClick={() => this.props.handleSelectedPenjualanVoucher(val)}>
                          <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </button>
                      </div>
                    }
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  loadSnackbar = () => {
    const { isSnackbar, codeError, message } = this.state;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "",
          horizontal: "",
        }}
        open={isSnackbar}
        autoHideDuration={5000}
        onClose={() => this.setState({ isSnackbar: false })}
      >
        <Alert onClose={() => this.setState({ isSnackbar: false })} severity={codeError == "EP-000" ? "success" : "error"}>
          <b style={{ fontSize: 20 }}>{message}</b>
        </Alert>
      </Snackbar>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ListPenjualanVoucher);
